"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockedTabModal = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Modal_1 = require("@skbkontur/react-ui/components/Modal");

var constants_1 = require("../../utils/constants");

exports.BlockedTabModal = function (_a) {
  var onClose = _a.onClose;
  return react_1.default.createElement(Modal_1.Modal, {
    width: constants_1.MODAL_WIDTH,
    onClose: onClose
  }, react_1.default.createElement(Modal_1.Modal.Header, null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"), react_1.default.createElement(Modal_1.Modal.Body, null, "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0441\u043F\u043B\u044B\u0432\u0430\u044E\u0449\u0438\u0435 \u043E\u043A\u043D\u0430 \u0432\xA0\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430."));
};